import { Calendar } from '@carbon/icons-react';

import { formatDateTimeVerbose } from 'utils/helpers';

import { useEventDetails } from '../event-detail.route';
import { EventOverviewCard } from './event-overview-card';

function formatUpdatePublishedAt(value: Date | string | null | undefined): string {
  if (!value) return 'Unknown';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return 'Unknown';
  return formatDateTimeVerbose(date);
}

export default function EventUpdates() {
  const data = useEventDetails();
  const updates = data?.event?.updates ?? [];

  return (
    <EventOverviewCard icon={<Calendar size={16} />} title="Event Updates">
      {!updates.length ? (
        <div className="type-body-sm text-center font-medium">No updates available</div>
      ) : (
        <div className="flex flex-col gap-5">
          {updates.map((update) => (
            <div key={update.upstream_event_update_id} className="flex flex-col gap-2">
              <div className="type-body-sm font-medium">{formatUpdatePublishedAt(update.update_published_at)}</div>
              <div className="type-body-xs leading-5">{update.update_text}</div>
            </div>
          ))}
        </div>
      )}
    </EventOverviewCard>
  );
}
